import { createContext } from 'react';

import type { IntercomHook } from './useInternalIntercom.ts';

export const IntercomContext = createContext<undefined | IntercomHook>(undefined);
